/**
 * Validates Norwegian bank account numbers (kontonummer) using the MOD11 algorithm.
 * Accepts formatted input with dots, spaces, or dashes which are stripped before validation.
 * Returns true for empty/null/undefined values (optional field).
 */

const WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2] as const;

function stripFormatting(input: string): string {
    return input.replace(/[.\s-]/g, "");
}

export function validateNorwegianBankAccount(value: string | null | undefined): boolean {
    if (!value) return true;

    const digits = stripFormatting(value);

    if (digits.length === 0) return true;
    if (digits.length !== 11) return false;
    if (!/^\d{11}$/.test(digits)) return false;

    let sum = 0;
    for (let i = 0; i < WEIGHTS.length; i++) {
        sum += parseInt(digits[i], 10) * WEIGHTS[i];
    }

    const remainder = sum % 11;

    // Remainder 1 means check digit would be 10, which is invalid
    if (remainder === 1) return false;

    const expectedCheckDigit = remainder === 0 ? 0 : 11 - remainder;
    const actualCheckDigit = parseInt(digits[10], 10);

    return actualCheckDigit === expectedCheckDigit;
}
